import { useNavigate } from '@remix-run/react';
import { useEffect } from 'react';
import { proxy, useSnapshot } from 'valtio';

export const auth = proxy({
  initialized: false,
  isAuthenticated: false,
});

export const authenticate = () => {
  auth.isAuthenticated = true;
  auth.initialized = true;
};

export const useIsAuthenticated = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useSnapshot(auth);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login');
    }
  }, [isAuthenticated, navigate]);
};
